import { useState } from "react";
import PointOfCareLaunchSelector from "./PointOfCareLaunchSelector";

const ChevronIcon = ({ direction }) => (
  <svg
    className="h-4 w-4"
    aria-hidden="true"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d={direction === "left" ? "M15 19l-7-7 7-7" : "M9 5l7 7-7 7"}
    />
  </svg>
);

export default function ProviderContextPanel({
  specialtyDisplayName,
  canSwitchSpecialty,
  onSwitchSpecialty,
  showPointOfCare,
  currentSta3n,
  fhirServer,
}) {
  const [isExpanded, setIsExpanded] = useState(true);

  // One toggle button for both states, so it keeps keyboard focus when pressed.
  const toggleButton = (
    <button
      type="button"
      onClick={() => setIsExpanded((expanded) => !expanded)}
      aria-label={isExpanded ? "Collapse provider context" : "Expand provider context"}
      aria-expanded={isExpanded}
      aria-controls={isExpanded ? "provider-context-details" : undefined}
      className="absolute -right-8 top-1/2 -translate-y-1/2 rounded-full border border-sky-300 bg-white p-1.5 text-sky-700 shadow-sm transition-colors hover:bg-sky-50"
    >
      <ChevronIcon direction={isExpanded ? "left" : "right"} />
    </button>
  );

  return (
    <div
      className={`relative mt-3 mb-2 mr-10 w-full max-w-md ${
        isExpanded ? "" : "flex h-10 items-center"
      }`}
    >
      {isExpanded ? (
        <div
          id="provider-context-details"
          className="rounded-2xl border border-sky-200 bg-gradient-to-r from-sky-50 to-blue-50 px-3.5 py-3 shadow-sm"
        >
          <div className="grid grid-cols-1 gap-2 sm:grid-cols-[minmax(0,1fr)_auto] sm:items-center sm:gap-4">
            <div className="min-w-0">
              <h2 className="text-xs font-semibold uppercase tracking-wide text-sky-700">
                Provider Specialty
              </h2>
              <p className="text-base font-semibold text-sky-900 break-words">
                {specialtyDisplayName} Provider
              </p>
            </div>
            {canSwitchSpecialty && (
              <div className="flex w-full flex-col gap-2 sm:w-auto sm:flex-row sm:items-center">
                <button
                  type="button"
                  onClick={onSwitchSpecialty}
                  className="w-full shrink-0 rounded-lg border border-sky-300 bg-white px-3 py-1.5 text-sm font-semibold text-sky-700 transition-colors hover:bg-sky-100 sm:w-auto"
                >
                  Switch specialty
                </button>
              </div>
            )}
          </div>

          {showPointOfCare && (
            <PointOfCareLaunchSelector
              currentSta3n={currentSta3n}
              fhirServer={fhirServer}
              embedded
            />
          )}
        </div>
      ) : (
        <div className="w-full border-b-2 border-sky-300" />
      )}
      {toggleButton}
    </div>
  );
}
